import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { CmsConverterService, defaultTextInput } from '../../../../services/cms-converter/cms-converter.service'
import { ConvertedComponentData, Image, TextInput } from '../../../types'

@Injectable({ providedIn: 'root' })
export class ColorContainerDotPlotsBoxConverter extends CmsConverterService<ColorContainerDotPlotsBoxData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const altText = formData.st_image_alternative_text?.value
    const title = formData.st_title_text?.value
    const lazyLoad = formData.st_lazy_load_image
    return {
      headline: formData.st_headline ?? defaultTextInput,
      overlayCaption: formData.st_caption_overlay ?? defaultTextInput,
      index: 0,
      image: CmsConverterService.mapImage(formData.st_image, lazyLoad, altText, title),
    }
  }
}

export const COLOR_CONTAINER_DOT_PLOTS_BOX_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, ColorContainerDotPlotsBoxData>>('ColorContainerDotPlotsBoxConverter')

export interface ColorContainerDotPlotsBoxData extends ConvertedComponentData {
  headline: TextInput;
  overlayCaption: TextInput;
  image: Image;
  index: number;
}
